import React from 'react';

// Google-only sign-in. The password form was removed on user request —
// only teammates on the GOOGLE_LOGIN_ALLOWLIST env var can sign in, and
// only via the Emergent-managed Google flow. The backend password
// endpoint still exists so pytest and curl regression tests keep working.
//
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH. The redirect is built from window.location.origin
// so the user comes back to whatever host they signed in from (preview
// vs prod).
export default function SignIn() {
  const startGoogleSignIn = () => {
    const redirectUrl = window.location.origin + '/';
    window.location.href = 'https://auth.emergentagent.com/?redirect=' + encodeURIComponent(redirectUrl);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.05fr_1fr]">
      {/* Left editorial panel */}
      <div className="relative hidden lg:flex flex-col justify-between bg-indie-navy text-indie-cream p-12 overflow-hidden">
        <div className="label-editorial-cream">Indie Law · LLC</div>
        <div>
          <div className="label-editorial-cream mb-4">Financial Operating System</div>
          <h1 className="text-5xl xl:text-6xl font-semibold tracking-tight text-white leading-[1.05]">
            Where we are.
            <br />
            Where we&apos;re going.
            <br />
            <span className="text-indie-yellow">Every day.</span>
          </h1>
          <p className="mt-6 text-indie-cream/70 max-w-lg text-lg leading-relaxed">
            The financial operating system for boutique trademark law. Live P&amp;L, cash runway, scenario planning, and budget-vs-actuals — one signed-in view for the whole team.
          </p>
        </div>
        <div className="text-xs text-indie-cream/50 tracking-wider uppercase">
          Restricted access · v1.0
        </div>
      </div>

      {/* Right sign-in panel */}
      <div className="flex items-center justify-center p-6 sm:p-12 bg-indie-paper">
        <div className="w-full max-w-md" data-testid="signin-form">
          <div className="label-editorial mb-3">Welcome back</div>
          <h2 className="text-3xl font-semibold text-indie-navy tracking-tight">Sign in to Command Center</h2>
          <p className="mt-2 text-sm text-indie-ink/70">
            Sign in with your <span className="font-medium text-indie-cobalt">@indielaw.com</span> Google account. Access is limited to the teammate allowlist.
          </p>

          <button
            type="button"
            data-testid="signin-google-btn"
            onClick={startGoogleSignIn}
            className="mt-8 w-full bg-white border border-indie-navy/25 text-indie-ink font-semibold py-3.5 flex items-center justify-center gap-3 hover:bg-indie-cream hover:border-indie-navy transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            Continue with Google
          </button>

          <div className="mt-6 pt-6 border-t border-indie-navy/10 text-xs text-indie-ink/55 leading-relaxed">
            Need access? Ask an admin to add you to the Google sign-in allowlist. Any @indielaw.com Google account not on the list will be denied at sign-in.
          </div>
        </div>
      </div>
    </div>
  );
}
